import { fetchTrackingRecordSave } from ".";

export const useTrackingRecordSave = () => ({
  mutate: fetchTrackingRecordSave,
});
